export class LoggingConfig {
  dsn?: string;
  release?: string;
  environment?: string;
  tracesSampleRate?: number;
  tracingOrigins?: string[];
}
